import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'pedidoEstado'
})
export class PedidoEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    switch (value) {
      case '1':
        label = 'Pendiente';
        cssClass = 'badge-estado-info';
        break;
      case '2':
        label = 'En proceso';
        cssClass = 'badge-estado-warning';
        break;
      case '3':
        label = 'Servido';
        cssClass = 'badge-estado-success';
        break;
      case '40':
        label = 'Solicita Cancelar';
        cssClass = 'badge-estado-danger';
        icon = '<i class="fa-regular fa-user me-1"></i>';
        break;
      case '4':
        label = 'Cancelado';
        cssClass = 'badge-estado-danger';
        strong = true;
        break;
      case '50':
        label = 'Solicita servir con faltas';
        cssClass = 'badge-estado-success';
        icon = '<i class="fa-regular fa-user me-1"></i>';
        break;
      case '5':
        label = 'Servido con faltas';
        cssClass = 'badge-estado-success';
        strong = true;
        break;
      case '6':
        label = 'Complementario';
        cssClass = 'badge-estado-info';
        icon = '<i class="fa fa-circle-plus me-1"></i>';
        break;
      case '8':
        label = 'Incidencia';
        cssClass = 'badge-estado-danger';
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(String(value));
    }

    // Construir HTML final
    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
